import { AuthShell } from '@/components/Auth/AuthShell';
import { usePageContext } from '@/renderer/utils/usePageContext';

import RequestReset from './components/RequestReset';
import SetNewPassword from './components/SetNewPassword';

export default function ForgotPassword() {
  const { urlParsed } = usePageContext();
  const { email, code } = urlParsed.search;

  // Render
  return (
    <AuthShell>
      {!email && !code ? <RequestReset /> : <SetNewPassword email={email} code={code} />}
    </AuthShell>
  );
}
